/** @jsx jsx */

import {
  Fragment as _,
  useState,
  createContext,
  useContext,
  memo,
  useEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import { useSelector } from 'react-redux';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import EditMarker from 'components/UI/EditMarker';
import HeaderStandard from 'components/Header';
import { HeaderGraphic } from './HeaderGraphic';
import { useHeader } from 'services/useHeader';
import getBlockById from 'services/apiHelpers/getBlockById';
import { getIsFirstInteraction } from 'services/getIsFirstInteraction';

const defaultHeaderHeight = 70;

const Header = (props: any) => {
  const { currentTopicIndex, topics } = props;
  const header = useHeader();
  const headerId = header?.block?.id;
  const { standard, graphic } = header;
  const { headerStyle = 'standard' } = header.props;

  const currentHeader = headerStyle === 'standard' ? standard : graphic;

  const { currentInteraction, focusedNodeId } = useSelector((state: any) => {
    return {
      currentInteraction: state.currentInteraction,
      focusedNodeId: state.focusedNodeId,
    } as any;
  });

  // this check is for first FIRST run. where the header might not yet be ' ready '
  const selected = headerId ? focusedNodeId === headerId : false;

  const { headerHeight = defaultHeaderHeight } = currentHeader?.props;
  const editWrapperMargin = 3;

  const isFirstInteraction = getIsFirstInteraction(topics, currentInteraction);

  const height =
    headerStyle === 'standard'
      ? 60 + editWrapperMargin
      : (!isFirstInteraction ? defaultHeaderHeight : headerHeight) -
        editWrapperMargin * 2;

  return (
    <_>
      {headerStyle === 'standard' ? (
        <HeaderStandard
          currentTopicIndex={currentTopicIndex}
          topics={topics}
          headerProps={standard.props}
        />
      ) : (
        <HeaderGraphic
          currentTopicIndex={currentTopicIndex}
          topics={topics}
          headerProps={graphic.props}
          isFirstInteraction={isFirstInteraction}
        />
      )}

      {window.dev() && (
        <div
          style={{
            position: 'fixed',
            left: 0,
            top: 0,
            width: '100vw',
            height,
            // setting the index at 1 seems to keep it on top of
            // 2147483647 < max zIndex not needed
            zIndex: 1,
          }}
        >
          <div
            css={css({
              position: 'absolute',
              left: editWrapperMargin,
              top: editWrapperMargin,
              width: `calc(100vw - ${editWrapperMargin * 2}px)`,
              height: '100%',
              boxShadow: `0 0 0 1px ${
                selected ? '#ff0063' : 'rgba(0,0,0, 0.2)'
              }`,
              transition: 'box-shadow 0.2s',
              ...(!selected && {
                cursor: 'pointer',
                ':hover': {
                  boxShadow: `0 0 0 1px rgba(0,0,0,0.1)`,
                },
              }),
              zIndex: 1,
            })}
            onClick={() => {
              setCurrentBlock({ id: headerId });
            }}
          >
            {!selected && <EditMarker />}
          </div>
        </div>
      )}
    </_>
  );
};

export default Header;
// () => null;
// Header;
